/**
 * @desc 导入
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: Array<defs.appCenter.AppDomainMenuAggregateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/menu/import`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
